import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Intercom from '@intercom/messenger-js-sdk'

import './styles.scss'
import Sidebar from '../sidebars'
import SupportChatWidget from '../support-chat-widget'
import uris from '../../../config/uris'
import UserLimitExceedModal from './limit-exceed'
import { MaxLimitAction } from '../../../store/slices/internal/maxLimit'
import { decryptData, encryptData } from '../../../helpers/encrypt/crypto-encrypt'
import { GetTourListAction } from '../../../store/slices/generics/tourSlice'
import { Tour } from 'antd'
import { getPendingTourConfig, handleFinishTour } from '../../../config/tourConfig'
import { FeaturesModal } from './tour-modal'

const LayoutMain = ({ showSidebar, Component }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const intercomApiBase = 'https://api-iam.intercom.io'
    const intercomAppId = 'ldw82ef7'
    const currentPath = window.location.pathname

    let user_decrypt = decryptData(sessionStorage?.getItem('rqewseu'))
    const isLoggedIn = !!sessionStorage.getItem("rqewseu");
    const userEmail = user_decrypt?.usermail || ''
    const userName = user_decrypt?.userName || ''
    const userId = user_decrypt?.userId || ''

    const isSquarewellUser = userEmail?.split('@')[1] === 'squarewell-partners.com'

    const { otp: otpDetails } = useSelector((state) => state.otp)
    const { pendingTours: pendingTourItemsFromStore } = useSelector((state) => state.tourList?.pendingTourItems);

    const [hideSidebar, setHideSidebar] = useState(false)
    const [featuresModalOpen, setFeaturesModalOpen] = useState(false)
    const [tourOpen, setTourOpen] = useState(false);
    const [pendingTourItems, setPendingTourItems] = useState([]);

    const storeUserDetailsToLocalstorage = () => {
        localStorage.userDetails = encryptData(otpDetails)
    }

    const getLocalStorageUserDetails = () => {
        const userDetails = decryptData(localStorage.getItem('userDetails'))

        if (userDetails) {
            const { user } = userDetails

            let license = encryptData({
                accessLimits: JSON.stringify(user?.accessLimits || { playBooks: [] }),
            })

            sessionStorage.license = license

            let eqlwoer = encryptData({
                pilotUser: user?.roleDetails?.isPilotUser,
                role: user?.role,
                roleOptions: JSON.stringify(user.roleDetails.role),
            })
            sessionStorage.eqlwoer = eqlwoer

            let rqewseu = encryptData({
                userId: user._id,
                userName: user && user.name,
                usermail: user && user.email,
            })
            sessionStorage.rqewseu = rqewseu

            // Clear local storage item after moving to sessionstorage
            localStorage.removeItem('userDetails')

            return user
        }
    }

    const onStartTour = () => {
        setFeaturesModalOpen(false)
        setTourOpen(true)
    }

    const handleTourClose = () => {
        handleFinishTour(dispatch, pendingTourItemsFromStore)
        setTourOpen(false);
        setPendingTourItems([]);
    }

    useEffect(() => {
        if (otpDetails?.user) {
            const storedStripeUrl = decryptData(sessionStorage.getItem('stripeCheckoutUrl'))
            const storedStripeValues = decryptData(sessionStorage.getItem('stripeValue'))

            if (storedStripeUrl && storedStripeValues) {
                const stripeValues = JSON.parse(storedStripeValues)

                if (stripeValues?.pack && stripeValues.billingPeriod && storedStripeUrl) {
                    storeUserDetailsToLocalstorage()
                    navigate(uris?.stripeCheckout)
                }
            }
        }
    }, [])

    useEffect(() => {
        let role_decrypt = decryptData(sessionStorage.getItem('eqlwoer'))
        const userRole = role_decrypt?.role
        const userDetails = getLocalStorageUserDetails()

        if (!userRole) {
            if (!userDetails?.role) {
                navigate(uris.login)
                sessionStorage.clear()
            }
        }
    }, [Component])

    useEffect(() => {
        dispatch(MaxLimitAction())
    }, [])

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(GetTourListAction())
        }
    }, [isLoggedIn, currentPath])

    useEffect(() => {
        if (currentPath && pendingTourItemsFromStore?.length) {
            const tourItems = getPendingTourConfig(pendingTourItemsFromStore, currentPath)
            if (tourItems?.length > 0) {
                setPendingTourItems(tourItems);
                setFeaturesModalOpen(true);
            }
        }
    }, [currentPath, pendingTourItemsFromStore])

    return (
        <div className="layout-main">
            {/* <Intercom app_id={intercomAppId} api_base={intercomApiBase} user_id={userId} email={userEmail} name={userName} /> */}
            {isLoggedIn && <SupportChatWidget userEmail={userEmail} userName={userName} />}
            <div className="layout-main-container">
                <FeaturesModal open={featuresModalOpen} onStartTour={onStartTour} />
                <Tour open={tourOpen} onClose={handleTourClose} steps={pendingTourItems} closeIcon={false} />
                {showSidebar && (
                    <div className={`sidebar-container ${hideSidebar ? 'sidebar-short' : 'sidebar-full'}`}>
                        <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
                    </div>
                )}
                <div className={`component-container ${hideSidebar ? 'extended-container' : 'regular-container'}`}>
                    <UserLimitExceedModal />
                    <Component isSquarewellUser={isSquarewellUser} setHideSidebar={setHideSidebar} />
                </div>
            </div>
        </div>
    )
}

export default LayoutMain
